import script from "./index.vue?vue&type=script&setup=true&lang=ts"
export * from "./index.vue?vue&type=script&setup=true&lang=ts"

import "./index.vue?vue&type=style&index=0&id=2d062f2a&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/prod-hys-h5-5.0/hys-h5-5.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d062f2a"]])

export default __exports__